import React from 'react';
import PropTypes from 'prop-types';

const MobileArrowIcon = ({ width, height, rotate }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 13.839 7.914"
    style={{
      transform: `rotate(${rotate}deg)`,
    }}
  >
    <path
      d="M13.809-8.772l-.619-.619a.375.375,0,0,0-.531,0L7-3.744,1.341-9.391a.375.375,0,0,0-.531,0l-.619.619a.375.375,0,0,0,0,.531L6.734-1.7a.375.375,0,0,0,.531,0l6.544-6.544A.375.375,0,0,0,13.809-8.772Z"
      transform="translate(-0.08 9.501)"
    />
  </svg>
);

MobileArrowIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  rotate: PropTypes.number,
};

MobileArrowIcon.defaultProps = {
  width: 13.839,
  height: 7.914,
  rotate: 0,
};

export default MobileArrowIcon;
